import React, { useContext, useState } from 'react';
import t from 'react-translate';
import { get, useFieldArray, useFormContext } from 'react-hook-form';
import {
  LiveEventSession as LiveEventSessionType,
  SessionTypes,
  ZoomSession,
  getSession,
} from 'redux/schemas/models/live-event';
import NvIcon from 'shared/components/nv-icon';
import LiveEventSession from './live-event-session';
import { LiveSessionFormContext } from './live-session-form';

const LiveEventSessions = () => {
  const {
    sessionType,
    isContentManagementCollection,
    onSessionDeleted,
    onHostValidation,
    isAccountLevel,
  } = useContext(LiveSessionFormContext);
  const { control, watch, formState } = useFormContext();
  const [validHosts, setValidHosts] = useState({ zoomHost: '', alternativeHosts: '' });
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'sessions',
    keyName: 'key',
  });

  const alternativeHosts = watch?.(`sessions[${fields.length - 1}].alternativeHosts`);
  const hasInvalidAlternativeHosts = !!get(formState.errors, `sessions[${fields.length - 1}].alternativeHosts`);

  const handleAddSession = () => {
    const newSession: LiveEventSessionType = getSession({
      sessionType,
      index: fields.length,
    });
    if (fields.length >= 0) {
      const lastSession = fields[fields.length - 1] as any;
      newSession.duration = lastSession.duration;
      newSession.timeZone = lastSession.timeZone;
      if (sessionType === SessionTypes.ZOOM) {
        (newSession as ZoomSession).authenticationEmail = validHosts.zoomHost;
        let alternativeHostsValue = '';
        if (isAccountLevel) {
          alternativeHostsValue = validHosts.alternativeHosts;
        } else if (!hasInvalidAlternativeHosts) {
          alternativeHostsValue = alternativeHosts;
        }
        (newSession as ZoomSession).alternativeHosts = alternativeHostsValue;
      }
    }
    append(newSession);
  };

  const handleRemoveSession = (index: number, id: number = null) => {
    remove(index);
    if (id) onSessionDeleted(id);
  };

  return (
    <React.Fragment>
      {fields.map((session: any, index) => (
        <div key={session.id}>
          <LiveEventSession
            session={{ ...session, index }}
            delete={() => handleRemoveSession(index, session.id)}
            canDelete={fields.length > 1}
            showIndex={fields.length > 1}
            onHostValidation={(isValid, hosts, allValid) => {
              setValidHosts(prev => (isValid
                ? { ...prev, ...hosts }
                : prev));
              onHostValidation?.(allValid);
            }}
          />
        </div>
      ))}
      {!isContentManagementCollection && (
        <div className='d-flex mt-4 mb-5'>
          <span className='d-flex text-primary text-regular cursor-pointer' onClick={handleAddSession}>
            <NvIcon icon='add' size='small' className='text-primary mr-2 cursor-pointer gray-3' />
            {t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.MODAL.ADD_SESSION()}
          </span>
        </div>
      )}
    </React.Fragment>
  );
};

export default LiveEventSessions;
